// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const woodenBridge = defineModel({
  id: "wooden-bridge",
  batchId: "future",
  name: "Wooden bridge",
  tags: ["building","wooden","bridge","low-poly","age-of-mcp","future","water"],
  summary: "A timber bridge — carries a path or road across a stream or gap.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.9,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [-0.6, 0.341, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [0.6, 0.341, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.75, 0.35, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.75, 0.35, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.75, 0.35, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.75, 0.35, 0.75] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [-0.6, 0.341, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [0.6, 0.341, 0] },
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.06), color: "#6f4a26", position: [0, 0.57, 0.27] },
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.06), color: "#6f4a26", position: [0, 0.57, -0.27] },
      { geometry: new THREE.BoxGeometry(1.7, 0.05, 0.7), color: "#9a6a3c", position: [0, 0.62, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, 0.75] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [-0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [-0.6, 0.341, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, -0.29] },
      { geometry: new THREE.BoxGeometry(0.07, 0.62, 0.07), color: "#5f3f22", position: [0.6, 0.31, 0.29] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.6), color: "#5f3f22", position: [0.6, 0.341, 0] },
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.06), color: "#6f4a26", position: [0, 0.57, 0.27] },
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.06), color: "#6f4a26", position: [0, 0.57, -0.27] },
      { geometry: new THREE.BoxGeometry(1.7, 0.05, 0.7), color: "#9a6a3c", position: [0, 0.62, 0] },
      { geometry: new THREE.BoxGeometry(1.7, 0.04, 0.04), color: "#7a522e", position: [0, 0.88, -0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [-0.755556, 0.75, -0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [-0.377778, 0.75, -0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0, 0.75, -0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0.377778, 0.75, -0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0.755556, 0.75, -0.31] },
      { geometry: new THREE.BoxGeometry(1.7, 0.04, 0.04), color: "#7a522e", position: [0, 0.88, 0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [-0.755556, 0.75, 0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [-0.377778, 0.75, 0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0, 0.75, 0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0.377778, 0.75, 0.31] },
      { geometry: new THREE.BoxGeometry(0.04, 0.26, 0.04), color: "#7a522e", position: [0.755556, 0.75, 0.31] },
    ] },
  ],
  animations: [],
});
